import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import HeaderBis from "../components/layout/headerbis";
import backgroundImage from "./../assets/img/header1.webp";
import emailjs from "@emailjs/browser";

const Devis = () => {
  const formRef = useRef();

  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    codePostal: "",
    email: "",
    telephone: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const autoComment = params.get("commentaire") || "";

  useEffect(() => {
    if (autoComment) {
      setFormData((prev) => ({
        ...prev,
        message: autoComment,
      }));
    }
  }, [autoComment]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
  e.preventDefault();
  if (isSubmitting) return;
  setIsSubmitting(true);

  emailjs
    .sendForm(
      "service_uzpw3gm",
      "template_9ql96rk",
      formRef.current,
      { publicKey: "RTPmtDubUhgHphxrl" }
    )
    .then(
      () => {
        alert("Votre demande de devis a bien été envoyée 👌");

        setFormData({
          lastName: "",
          firstName: "",
          codePostal: "",
          email: "",
          telephone: "",
          message: "",
        });

        formRef.current.reset();
        setIsSubmitting(false);
      },
      (error) => {
        console.log("FAILED...", error.text);
        alert("Erreur lors de l'envoi du formulaire ❌");
        setIsSubmitting(false);
      }
    );
  };


  return (
    <div>
      <HeaderBis
        backgroundImage={backgroundImage}
        title="DEVIS"
        desc="Démarrez votre projet avec un devis gratuit"
      />

      <div className="max-w-3xl mx-auto mt-16 p-6 bg-white shadow-lg rounded-2xl">
        <h2 className="text-3xl font-semibold text-[#13455a] text-center mb-8">
          Formulaire de demande de devis
        </h2>

        <form ref={formRef} onSubmit={handleSubmit} className="space-y-6">
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="text-[#13455a] font-medium mb-1">Nom</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#13455a]"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-[#13455a] font-medium mb-1">Prénom</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#13455a]"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="text-[#13455a] font-medium mb-1">
                Code postal - Estimation Transport
              </label>
              <input
                type="text"
                name="codePostal"
                value={formData.codePostal}
                onChange={handleChange}
                required
                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#13455a]"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-[#13455a] font-medium mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#13455a]"
              />
            </div>
          </div>

          <div className="flex flex-col">
            <label className="text-[#13455a] font-medium mb-1">Téléphone</label>
            <input
              type="text"
              name="telephone"
              value={formData.telephone}
              onChange={handleChange}
              required
              className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#13455a]"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-[#13455a] font-medium mb-1">Commentaire</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#13455a]"
              placeholder="Décrivez votre projet ou vos besoins..."
            ></textarea>
          </div>

          <div className="text-center">
            <button type="submit" disabled={isSubmitting} className={`bg-[#005478] text-white px-8 py-3 rounded-xl font-semibold shadow-md transition-all ${isSubmitting ? "opacity-60 cursor-not-allowed" : "hover:bg-[#13455a]"}`}>
              {isSubmitting ? "Envoi en cours..." : "Envoyer ma demande"}
            </button>
          </div>
        </form>
      </div>

      <div className="h-20"></div>
    </div>
  );
};

export default Devis;
